module.exports = __webpack_public_path__ + "8556e9fdc12a5970ca3bbf42188c9dda.png";


//////////////////
// WEBPACK FOOTER
// ./content/help/research/insilico/scoring-img/img11.png
// module id = 1317
// module chunks = 0